var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.icon)?_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"size":"small"}},[_vm._v(_vm._s(_vm.icon))])],1):_vm._e(),_vm._v(_vm._s(_vm.createdTime)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }